import type { OrderSummary } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';
import { type OrderStatusTone, orderStatusTone } from '../model/status-tone';

interface OrderStatusBadgeProps {
  readonly order: Pick<OrderSummary, 'status' | 'fulfillmentStatus' | 'displayStatus'>;
  readonly className?: string;
}

/** 내 견적 배지(QuoteStatusBadge)와 같은 각진 작은 칩. 라임은 고객이 결제해야 하는 상태에만 쓴다. */
const TONE_CLASS: Readonly<Record<OrderStatusTone, string>> = {
  action: 'bg-brand-lime text-black',
  progress: 'border border-foreground/20 text-foreground',
  complete: 'bg-foreground text-background',
  closed: 'bg-muted text-muted-foreground',
};

/** 주문 상태 배지 — 서버가 계산한 고객 화면 이름(displayStatus)을 상태의 결(orderStatusTone)에 맞춰 칠한다. */
export const OrderStatusBadge = ({ order, className }: OrderStatusBadgeProps): ReactElement => (
  <span
    className={cn(
      'inline-flex h-6 items-center px-2 text-xs font-semibold whitespace-nowrap',
      TONE_CLASS[orderStatusTone(order)],
      className,
    )}
  >
    {order.displayStatus}
  </span>
);
